import moment from "moment";

const dateFormatter = new Intl.DateTimeFormat("en-us");
const dateTimeFormatter = new Intl.DateTimeFormat("en-us", {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
});

/**
 * Creates and returns a Date object from a given Date string
 */
export function createDateFromString(incomingDateString: string) {
  return new Date(Date.parse(incomingDateString));
}

/**
 * Formats a Date string in MM/DD/YYYY format.
 */
export function formatISODate(isoDate: string) {
  return dateFormatter.format(createDateFromString(isoDate));
}

/**
 * Formats a Date object in MM/DD/YYYY format.
 */
export function formatDate(incomingDate: Date) {
  return dateFormatter.format(incomingDate);
}

/**
 * Formats a Date object in MM/DD/YYYY HH:MM:SS AM/PM format.
 */
export function formatDateTime(incomingDate: Date) {
  return dateTimeFormatter.format(incomingDate);
}

function AddMinutesToDate(date: Date, minutes: number) {
  return new Date(new Date(date).getTime() + minutes * 60000);
}

/**
 * Given a DateOnly string in YYYY-MM-DD format, returns a date object with a user-localized midnight time (00:00:00)
 */
export function createLocalizedDateFromDateOnlyString(
  incomingDateOnlyString: string
) {
  const rawDate = new Date(Date.parse(incomingDateOnlyString));
  const offsetInMinutes = rawDate.getTimezoneOffset();
  const newDate = AddMinutesToDate(rawDate, offsetInMinutes);
  return newDate;
}

/**
 * Given a DateTime string with time zone info appended, returns a date object that has been converted to the user's local date and time
 */
export function createLocalizedDateFromUtcDateTimeString(
  incomingUtcDate: string
) {
  return new Date(incomingUtcDate);
}

/**
 * Formats an ISO date string in YYY-MM-DD format.
 */
export function formatDateOnlyStringFromString(incomingDate: string) {
  return incomingDate.split("T")[0];
}

/**
 * Formats a Date object in YYY-MM-DD format.
 */
export function formatDateOnlyString(incomingDate: Date) {
  return formatDateOnlyStringFromString(incomingDate.toISOString());
}

export function formatISODateTime(isoDateTime: string) {
  return dateTimeFormatter
    .format(new Date(Date.parse(isoDateTime)))
    .replace(/,/, "");
}

/**
 *
 * Formats a date time as a string relative to now.  Examples include:
 *   - 20 minutes ago
 *   - Yesterday
 *   - Last week
 */
export function formatFromNow(isoDateTime: string) {
  // So far, there is no good alternative to this in the Intl classes, so
  //  we're sticking with moment here.  We should try to call this wrapper
  //  instead of doing it in different components.
  //  We'll swap out the implementation when something better comes along
  return moment(new Date(Date.parse(isoDateTime))).fromNow();
}
